<template>
  <!-- 7. 成功案例 -->
  <div class="info-success-case" ref="dom">
    <div class="title pi-fz-30 pi-fw-900 pi-mg-bottom-40">
      成功案例 · 数字化转型与实践
    </div>
    <div
      class="case-tab-container"
      :class="isMobile || show ? 'animate__animated animate__fadeIn' : 'hide'"
    >
      <el-carousel
        ref="successCaseCarousel"
        :interval="5000"
        arrow="never"
        indicator-position="none"
        height="680px"
        @change="successCaseCarouselChangeHandler"
        style="width: 100%"
      >
        <el-carousel-item
          v-for="(pItem, pIndex) in successCaseLists"
          :key="'pindex-' + pIndex"
          style="width: 100%"
        >
          <div class="case-tabs">
            <div
              class="case-tab-item"
              v-for="(item, index) in pItem"
              :key="index"
            >
              <div class="item-img">
                <div
                  class="item-bg"
                  :style="{ 'background-image': 'url(' + item.img + ')' }"
                ></div>
                <!-- <img src="@/assets/site/img_apj-logo-long.png" /> -->
              </div>
              <div class="item-content">
                <span class="item-title">{{ item.subTitle }}</span>
                <span class="item-sub-title">{{ item.title }}</span>
                <span class="item-desc">{{ item.desc }}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="case-tabs-pager">
        <div
          class="iconfont iconicon_next case-tab-next"
          @click="successCaseCarouselChange('next')"
        ></div>
        <div
          class="iconfont iconicon_pre case-tab-previou"
          @click="successCaseCarouselChange('prev')"
        ></div>
        <div class="case-tab-page">
          <span class="case-current-page">{{
            successCaseListPager.currentPage | numberFormat
          }}</span>
          <span class="case-total-page"
            >/ {{ successCaseListPager.totalPage | numberFormat }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../../data";
import { isMobile } from "@/utils";
import { slicingArray, numberFormat } from "@/utils";
export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: isMobile(),
      successCaseListPager: {
        currentPage: 1,
        totalPage: 2,
      },
      successCaseLists: slicingArray(data.successCaseList, 3, 2),
    };
  },
  filters: {
    numberFormat(val) {
      return numberFormat(val);
    },
  },
  methods: {
    loadInit() {
      return this.$refs.dom;
    },
    successCaseCarouselChange(type) {
      let successCaseCarousel = this.$refs["successCaseCarousel"];
      if (type == "next") {
        successCaseCarousel.next();
      } else {
        successCaseCarousel.prev();
      }
    },
    successCaseCarouselChangeHandler(index) {
      this.successCaseListPager.currentPage = index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
// 成功案例
.info-success-case {
  width: 100%;
  padding: 90px 8vw;
  // margin: 90px;

  .case-tab-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .case-tabs {
      display: flex;
      justify-content: flex-start;

      .case-tab-item {
        width: calc(100% / 3);
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        border: 1px solid #dddddd;

        .item-img {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;
          height: 225px;
          overflow: hidden;

          .item-bg {
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            background-size: cover;
            background-repeat: no-repeat;
            height: 225px;
            width: 100%;
          }

          img {
            z-index: 100;
            margin-top: -60px;
          }
        }

        .item-content {
          padding: 50px 40px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;

          .item-title {
            font-size: 24px;
            line-height: 40px;
            font-weight: bold;
          }

          .item-sub-title {
            color: #c5c5c5;
          }

          .item-desc {
            margin-top: 20px;
          }
        }
      }

      .case-tab-item:hover {
        cursor: pointer;
        margin-top: -2px;
        box-shadow: 0 2px 5px #dddddd;

        .item-bg {
          animation: bigger 0.8s;
          transform: rotate(10deg) scale(1.4);
        }
      }
    }

    .case-tabs-pager {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
      // padding-left: 50px;

      .case-tab-next,
      .case-tab-previou {
        margin-bottom: 20px;
        width: 80px;
        height: 80px;
        font-size: 80px;
        line-height: 80px;
        border: 1px solid #929292;
        border-radius: 100%;
        color: #929292;
      }

      .case-tab-next:hover,
      .case-tab-previou:hover {
        cursor: pointer;
        color: #ec0022;
        border-color: #ec0022;
      }

      .case-tab-page {
        margin-top: 80px;
        border-bottom: 1px solid #929292;

        .case-current-page {
          font-size: 40px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/row_5/index.vue